// Nested Form Controller — extends stimulus-rails-nested-form
// Adds: data-type (multiple templates/targets), data-placeholder (multi-level nesting),
// and backward compat with "container" target used in existing views.
import RailsNestedForm from "@stimulus-components/rails-nested-form";

export default class extends RailsNestedForm {
  static targets = ["target", "template", "container"];
  static values = {
    wrapperSelector: { type: String, default: ".nested-form-wrapper" },
  };

  add(event) {
    event.preventDefault();

    const type = event.currentTarget.dataset.type;
    const placeholder = event.currentTarget.dataset.placeholder || "NEW_RECORD";
    let template, insertTarget;

    if (type) {
      template = this.templateTargets.find((t) => t.dataset.type === type);
      insertTarget =
        this._findTargetByType(this.targetTargets, type) ||
        this._findTargetByType(this.containerTargets, type);
    } else {
      template = this.templateTarget;
      insertTarget = this._firstInsertTarget();
    }

    if (template && insertTarget) {
      const content = template.innerHTML.replace(
        new RegExp(placeholder, "g"),
        new Date().getTime().toString()
      );
      insertTarget.insertAdjacentHTML("beforeend", content);
    }
  }

  remove(event) {
    event.preventDefault();

    const wrapper =
      event.target.closest(this.wrapperSelectorValue) ||
      event.target.closest(".nested-fields");
    if (!wrapper) return;

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      const destroyField = wrapper.querySelector("input[name*='_destroy']");
      if (destroyField) {
        destroyField.value = "1";
        wrapper.style.display = "none";
      } else {
        wrapper.remove();
      }
    }
  }

  // Private helpers

  _findTargetByType(targets, type) {
    return targets.find((t) => t.dataset.type === type);
  }

  _firstInsertTarget() {
    if (this.hasTargetTarget) return this.targetTarget;
    if (this.hasContainerTarget) return this.containerTarget;
    return null;
  }
}
